import {RootState} from '../../utils/types';

export const currentStrokeSelector=(state:RootState)=>state.currentStroke
